export enum AUTH0_ROLE {
  NONE = '',
  PROSPECT = 'Prospect',
  CLIENT = 'Client',
  BUSINESS = 'Business',
  ADMIN = 'Admin',
  SIGNUP = 'Signup',
  TRIAL = 'Trial',
  EXPIRED = 'Expired'
}

export interface UserProfile {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  role: AUTH0_ROLE;
  account?: string;
  trialDaysLeft: number | null;
  companyName?: string;
}

export interface UserProfileResponse {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  lastLogin: string;
  createdAt: string;
  role: AUTH0_ROLE;
  brands: { key: string; name: string }[];
  organizations: { key: string }[];
  account?: { key: string; name: string };
  verifiedEmail?: boolean;
  companyName?: string;
  jobTitle?: string;
  trialDaysLeft?: number;
  isNewUser?: boolean;
}